import type { ImageModel } from '@rocco/types/image-model';
import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';

interface ProfessionalLogoTileViewModel {
    image: ImageModel;
    background: string;
}

export interface ProfessionalTileViewModel {
    id: number;
    title: string;
    image: ImageModel;
    logo: ProfessionalLogoTileViewModel | null;
    category: string;
    services: string[];
    link: string;
    location: string;
    /**
     * When false, `location` is a serviceable-area label and must not render with
     * a map pin. Omitted or true means a physical premises.
     */
    showLocationPin?: boolean;
    content?: string;
    hasAwards: boolean;
    memberSince: number | null;
    /**
     * The item's tracked external website link, or null/absent when it has none.
     * Resolved server-side with the same fallback the detail-page CTA uses (a
     * product's own Website, else the professional's) and already carries the
     * UTM / `_ap_pageid` params. Only populated on surfaces that fetch it.
     */
    website?: string | null;
    video?: string[];
    /** Product category URL segments for products sold by this professional */
    productCategorySegments?: string[];
}

export const isProfessionalTileViewModel = (
    model: TileableModel,
): model is ProfessionalTileViewModel =>
    model && 'category' in model && 'memberSince' in model;
